<template>
  <div class="range-slider">
    <vue-range-slider
      v-model="value"
      :min="min"
      :max="max"
      :formatter="formatter"
    ></vue-range-slider>
  </div>
</template>
<script>
import "vue-range-component/dist/vue-range-slider.css";
import VueRangeSlider from "vue-range-component";
export default {
  components: {
    VueRangeSlider,
  },
  data() {
    return {
      value: [0, 300000],
    };
  },
  created() {
    this.min = 0;
    this.max = 300000;
    this.formatter = (value) => `${value}`;
  },
};
</script>
<style scoped lang="scss">
@import "@/assets/stylesheets/application";
/deep/.vue-range-slider.slider-component {
  .slider {
    background-color: #cecece;
    .slider-dot {
      border: 1px solid $blue-primary;
    }
    .slider-process {
      background-color: $blue-primary;
    }
  }
  .slider-tooltip-wrap .slider-tooltip {
    background-color: transparent;
    border: 0 transparent;
    color: $black;
    font-family: "Poppins", sans-serif;
    font-size: 1em;
    font-weight: 500;
    letter-spacing: 1px;
    padding: 0;
    z-index: 1000;
  }
}
</style>
